/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authCallbackRouteImport } from './routes/(auth)/callback'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedCommandsIndexRouteImport } from './routes/_authenticated/commands/index'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedTicketingTranscriptsIndexRouteImport } from './routes/_authenticated/ticketing/transcripts/index'
import { Route as AuthenticatedTicketingTicketsIndexRouteImport } from './routes/_authenticated/ticketing/tickets/index'
import { Route as AuthenticatedTicketingPanelIndexRouteImport } from './routes/_authenticated/ticketing/panel/index'
import { Route as AuthenticatedTicketingCategoriesIndexRouteImport } from './routes/_authenticated/ticketing/categories/index'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authCallbackRoute = authCallbackRouteImport.update({
  id: '/(auth)/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCommandsIndexRoute =
  AuthenticatedCommandsIndexRouteImport.update({
    id: '/commands/',
    path: '/commands/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingTranscriptsIndexRoute =
  AuthenticatedTicketingTranscriptsIndexRouteImport.update({
    id: '/ticketing/transcripts/',
    path: '/ticketing/transcripts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingTicketsIndexRoute =
  AuthenticatedTicketingTicketsIndexRouteImport.update({
    id: '/ticketing/tickets/',
    path: '/ticketing/tickets/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingPanelIndexRoute =
  AuthenticatedTicketingPanelIndexRouteImport.update({
    id: '/ticketing/panel/',
    path: '/ticketing/panel/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTicketingCategoriesIndexRoute =
  AuthenticatedTicketingCategoriesIndexRouteImport.update({
    id: '/ticketing/categories/',
    path: '/ticketing/categories/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/callback': typeof authCallbackRoute
  '/login': typeof authLoginRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/commands': typeof AuthenticatedCommandsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/ticketing/categories': typeof AuthenticatedTicketingCategoriesIndexRoute
  '/ticketing/panel': typeof AuthenticatedTicketingPanelIndexRoute
  '/ticketing/tickets': typeof AuthenticatedTicketingTicketsIndexRoute
  '/ticketing/transcripts': typeof AuthenticatedTicketingTranscriptsIndexRoute
}
export interface FileRoutesByTo {
  '/callback': typeof authCallbackRoute
  '/login': typeof authLoginRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/commands': typeof AuthenticatedCommandsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/ticketing/categories': typeof AuthenticatedTicketingCategoriesIndexRoute
  '/ticketing/panel': typeof AuthenticatedTicketingPanelIndexRoute
  '/ticketing/tickets': typeof AuthenticatedTicketingTicketsIndexRoute
  '/ticketing/transcripts': typeof AuthenticatedTicketingTranscriptsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/(auth)/callback': typeof authCallbackRoute
  '/(auth)/login': typeof authLoginRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/commands/': typeof AuthenticatedCommandsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/ticketing/categories/': typeof AuthenticatedTicketingCategoriesIndexRoute
  '/_authenticated/ticketing/panel/': typeof AuthenticatedTicketingPanelIndexRoute
  '/_authenticated/ticketing/tickets/': typeof AuthenticatedTicketingTicketsIndexRoute
  '/_authenticated/ticketing/transcripts/': typeof AuthenticatedTicketingTranscriptsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/callback'
    | '/login'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/errors/$error'
    | '/commands'
    | '/settings'
    | '/users'
    | '/ticketing/categories'
    | '/ticketing/panel'
    | '/ticketing/tickets'
    | '/ticketing/transcripts'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/callback'
    | '/login'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/errors/$error'
    | '/commands'
    | '/settings'
    | '/users'
    | '/ticketing/categories'
    | '/ticketing/panel'
    | '/ticketing/tickets'
    | '/ticketing/transcripts'
  id:
    | '__root__'
    | '/_authenticated'
    | '/(auth)/callback'
    | '/(auth)/login'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/errors/$error'
    | '/_authenticated/commands/'
    | '/_authenticated/settings/'
    | '/_authenticated/users/'
    | '/_authenticated/ticketing/categories/'
    | '/_authenticated/ticketing/panel/'
    | '/_authenticated/ticketing/tickets/'
    | '/_authenticated/ticketing/transcripts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authCallbackRoute: typeof authCallbackRoute
  authLoginRoute: typeof authLoginRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/callback': {
      id: '/(auth)/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof authCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/commands/': {
      id: '/_authenticated/commands/'
      path: '/commands'
      fullPath: '/commands'
      preLoaderRoute: typeof AuthenticatedCommandsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/transcripts/': {
      id: '/_authenticated/ticketing/transcripts/'
      path: '/ticketing/transcripts'
      fullPath: '/ticketing/transcripts'
      preLoaderRoute: typeof AuthenticatedTicketingTranscriptsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/tickets/': {
      id: '/_authenticated/ticketing/tickets/'
      path: '/ticketing/tickets'
      fullPath: '/ticketing/tickets'
      preLoaderRoute: typeof AuthenticatedTicketingTicketsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/panel/': {
      id: '/_authenticated/ticketing/panel/'
      path: '/ticketing/panel'
      fullPath: '/ticketing/panel'
      preLoaderRoute: typeof AuthenticatedTicketingPanelIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ticketing/categories/': {
      id: '/_authenticated/ticketing/categories/'
      path: '/ticketing/categories'
      fullPath: '/ticketing/categories'
      preLoaderRoute: typeof AuthenticatedTicketingCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedCommandsIndexRoute: typeof AuthenticatedCommandsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedTicketingCategoriesIndexRoute: typeof AuthenticatedTicketingCategoriesIndexRoute
  AuthenticatedTicketingPanelIndexRoute: typeof AuthenticatedTicketingPanelIndexRoute
  AuthenticatedTicketingTicketsIndexRoute: typeof AuthenticatedTicketingTicketsIndexRoute
  AuthenticatedTicketingTranscriptsIndexRoute: typeof AuthenticatedTicketingTranscriptsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedCommandsIndexRoute: AuthenticatedCommandsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedTicketingCategoriesIndexRoute:
    AuthenticatedTicketingCategoriesIndexRoute,
  AuthenticatedTicketingPanelIndexRoute: AuthenticatedTicketingPanelIndexRoute,
  AuthenticatedTicketingTicketsIndexRoute:
    AuthenticatedTicketingTicketsIndexRoute,
  AuthenticatedTicketingTranscriptsIndexRoute:
    AuthenticatedTicketingTranscriptsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authCallbackRoute: authCallbackRoute,
  authLoginRoute: authLoginRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
